import { createSlice } from '@reduxjs/toolkit';

// Load auth data from localStorage
const loadAuthData = () => {
  try {
    const authData = localStorage.getItem('authData');
    if (authData) {
      const { user, token, refreshToken } = JSON.parse(authData);
      return { isLogin: true, currentUser: user, token, refreshToken };
    }
  } catch (error) {
    console.error('Failed to load auth data:', error);
  }
  return { isLogin: false, currentUser: {}, token: null, refreshToken: null };
};

const initialState = loadAuthData();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      const { user, token, refreshToken } = action.payload;
      state.currentUser = user;
      state.token = token;
      state.refreshToken = refreshToken || null;
      state.isLogin = true;

      // Persist to localStorage
      localStorage.setItem('authData', JSON.stringify({ user, token, refreshToken: refreshToken || null }));
    },
    logout(state) {
      state.currentUser = {};
      state.token = null;
      state.refreshToken = null;
      state.isLogin = false;

      // Clear localStorage
      localStorage.removeItem('authData');
    },
  },
});

export const { setCurrentUser, logout } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
